import { render, staticRenderFns } from "./BusinessDetailsForm.vue?vue&type=template&id=f61f90c6&scoped=true&"
import script from "./BusinessDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./BusinessDetailsForm.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessDetailsForm.vue?vue&type=style&index=0&id=f61f90c6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61f90c6",
  null
  
)

export default component.exports